(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-components/assets/javascripts/outcome-row.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-components/assets/javascripts/outcome-row.js');
"use strict";


const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const _svs$components$tipse = svs.components.tipsen.couponComponents,
  Coupon = _svs$components$tipse.Coupon,
  useCouponContext = _svs$components$tipse.useCouponContext;
const useBranding = svs.components.tipsen.hooks.useBranding;
const selectSystemType = svs.components.tipsen.engine.selectors.couponSelectors.selectSystemType;
const SYSTEM_REDUCERA_FRITT = svs.components.tipsen.engine.constants.systems.SYSTEM_REDUCERA_FRITT;
const useCurrentDraw = svs.components.tipsen.drawProvider.hooks.useCurrentDraw;
const getProductBrandByDraw = svs.components.lbUtils.brandMapping.fn.getProductBrandByDraw;
const Outcome = svs.components.lbUi.outcome.Outcome;
const percentage = signDistribution => {
  const signDistributionPercentage = [];
  const totalRowValue = signDistribution.reduce((a, b) => a + b, 0);
  signDistributionPercentage[0] = signDistribution[0] ? "".concat(Math.round(signDistribution[0] / totalRowValue * 100), "%") : "".concat(0, "%");
  signDistributionPercentage[1] = signDistribution[1] ? "".concat(Math.round(signDistribution[1] / totalRowValue * 100), "%") : "".concat(0, "%");
  signDistributionPercentage[2] = signDistribution[2] ? "".concat(Math.round(signDistribution[2] / totalRowValue * 100), "%") : "".concat(0, "%");
  return signDistributionPercentage;
};
const getBetOptionSign = (betOption, index, signDistribution, systemType) => {
  if (systemType === SYSTEM_REDUCERA_FRITT) {
    const percentages = percentage(signDistribution);
    return percentages[index];
  }
  return betOption.sign;
};
const OutcomeRow = _ref => {
  let _ref$buttonClassName = _ref.buttonClassName,
    buttonClassName = _ref$buttonClassName === void 0 ? '' : _ref$buttonClassName,
    _ref$eventNumber = _ref.eventNumber,
    eventNumber = _ref$eventNumber === void 0 ? 0 : _ref$eventNumber,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$isClickable = _ref.isClickable,
    isClickable = _ref$isClickable === void 0 ? false : _ref$isClickable,
    _ref$outcomeGroupInde = _ref.outcomeGroupIndex,
    outcomeGroupIndex = _ref$outcomeGroupInde === void 0 ? 0 : _ref$outcomeGroupInde,
    _ref$outcomes = _ref.outcomes,
    outcomes = _ref$outcomes === void 0 ? [] : _ref$outcomes,
    _ref$signDistribution = _ref.signDistribution,
    signDistribution = _ref$signDistribution === void 0 ? [] : _ref$signDistribution,
    _ref$signLabel = _ref.signLabel,
    signLabel = _ref$signLabel === void 0 ? '' : _ref$signLabel,
    _ref$boardIndex = _ref.boardIndex,
    boardIndex = _ref$boardIndex === void 0 ? 0 : _ref$boardIndex;
  const _useCouponContext = useCouponContext(),
    couponId = _useCouponContext.couponId;
  const draw = useCurrentDraw();
  const brandingList = useBranding();
  const brandingByDraw = getProductBrandByDraw(draw);
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  const systemType = useSelector(state => selectSystemType(state, couponId));
  const isReduceFree = systemType === SYSTEM_REDUCERA_FRITT;
  const classNames = ['pg_tipsen__outcome_row '];
  if (className) {
    classNames.push(className);
  }
  return React.createElement("div", {
    className: classNames.join(' ')
  }, signLabel && React.createElement("div", {
    "aria-label": "matematisk gardering",
    className: "f-normal"
  }, signLabel), outcomes.map((betOption, index) => {
    const dataTestId = "outcome_".concat(boardIndex, "_").concat(eventNumber, "_").concat(outcomeGroupIndex, "_").concat(index);
    return React.createElement(Outcome, {
      branding: branding,
      className: buttonClassName,
      dataTestId: dataTestId,
      hasUSign: betOption.hasUSign,
      isClickable: isClickable,
      isReduceFree: isReduceFree,
      isSelected: betOption.isSelected,
      key: "outcome_".concat(index + 1, "_").concat(betOption.sign),
      sign: getBetOptionSign(betOption, index, signDistribution, systemType)
    });
  }));
};
Coupon.OutcomeRow = OutcomeRow;

 })(window);